import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";

// Zaim engineering components
import MDBox from "components/MDBox";

// Zaim engineering example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import ReportsBarChart from "examples/Charts/BarCharts/ReportsBarChart";
import ReportsLineChart from "examples/Charts/LineCharts/ReportsLineChart";
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";

// Data
import reportsBarChartData from "layouts/dashboard/data/reportsBarChartData";
import reportsLineChartData from "layouts/dashboard/data/reportsLineChartData";
import apis from "../../context/api";
import { useNavigate } from "react-router-dom";

function Dashboard() {
  // const { sales, tasks } = reportsLineChartData;
  const navigate = useNavigate();
  const [counts, setCounts] = useState({});
  const [orders, setOrders] = useState([]);
  const [error, setError] = useState(null);
  const [chartData, setChartData] = useState({
    sales: {
      labels: [],
      datasets: {
        label: "Orders",
        data: [],
      },
    },
  });
  const navigateToPath = (page) => {
    console.log("cliecked " + page);
    navigate("/" + page);
  };
  const generateChartData = (rawData) => {
    const labels = rawData.map((entry) => entry.month);
    const data = rawData.map((entry) => entry.count);

    setChartData({
      sales: {
        labels,
        datasets: {
          label: "Mobile apps",
          data,
        },
      },
    });
  };
  useEffect(() => {
    apis
      .getDashboardTotals()
      .then((data) => {
        if (data) {
          setCounts(data);
        }
      })
      .catch(() => setError("Failed to load total"));

    apis
      .getOrdersPerMonth()
      .then((data) => {
        if (data && data.length > 0) {
          generateChartData(data);
        }
      })
      .catch(() => setError("Failed to load orders"));
    apis
      .getPendingOrder()
      .then((data) => {
        if (data && data.length > 0) {
          setOrders(data);
        }
      })
      .catch(() => setError("Failed to load pending orders"));
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="dark"
                icon="weekend"
                title="Products"
                count={counts.products}
                submitEvent={() => navigateToPath("products")}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                icon="leaderboard"
                title="Orders"
                count={counts.orders}
                submitEvent={() => navigateToPath("orders")}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="success"
                icon="store"
                title="Quotations"
                count={counts.quotations}
                submitEvent={() => navigateToPath("quotation")}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="primary"
                icon="person_add"
                title="Users"
                count={counts.users}
                submitEvent={() => navigateToPath("users")}
              />
            </MDBox>
          </Grid>
        </Grid>
        <MDBox mt={4.5}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={12} lg={12}>
              <MDBox mb={3}>
                <ReportsLineChart
                  color="success"
                  title="Monthly sales"
                  date="updated few min ago"
                  chart={chartData.sales}
                />
              </MDBox>
            </Grid>
            {/*<Grid item xs={12} md={6} lg={4}>*/}
            {/*  <MDBox mb={3}>*/}
            {/*    <ReportsLineChart*/}
            {/*      color="dark"*/}
            {/*      title="completed tasks"*/}
            {/*      description="Last Campaign Performance"*/}
            {/*      date="just updated"*/}
            {/*      chart={tasks}*/}
            {/*    />*/}
            {/*  </MDBox>*/}
            {/*</Grid>*/}
          </Grid>
        </MDBox>
        {/*<MDBox>*/}
        {/*  <Grid container spacing={3}>*/}
        {/*    <Grid item xs={12} md={6} lg={8}>*/}
        {/*      <Projects />*/}
        {/*    </Grid>*/}
        {/*    <Grid item xs={12} md={6} lg={4}>*/}
        {/*      <OrdersOverview />*/}
        {/*    </Grid>*/}
        {/*  </Grid>*/}
        {/*</MDBox>*/}
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Dashboard;
